import React from 'react'
import { Badge } from '@/shared/ui'

type VisionHeaderProps = {
  warningText?: string | null
}

export function VisionHeader({ warningText }: VisionHeaderProps) {
  const badgeText = String(warningText || '').trim()

  return (
    <div className="mb-6 flex items-center justify-between">
      <div className="space-y-1">
        <h1 className="text-2xl font-semibold">Visoes do mercado cripto</h1>
        <p className="text-sm text-foreground/70">
          Compartilhe leituras e percepcoes sobre o mercado de criptoativos.
        </p>
        {badgeText ? (
          <Badge variant="soft" color="warning" className="mt-2 whitespace-normal">
            {badgeText}
          </Badge>
        ) : null}
      </div>
    </div>
  )
}
